import React from 'react';
import { Card } from '@/components/ui/card';

/** Amount breakdown card: gross / discount / net (or single Total when no gross). */
export default function AmountCard({ booking }) {
  const hasGross = booking.gross_total && booking.gross_total > 0;
  const hasDiscount = hasGross && booking.gross_total > booking.final_total;
  const finalTotal = booking.final_total ?? 0;

  if (!hasGross) {
    return (
      <Card className="p-6 bba-card bba-card-accent border-orange-400 bg-orange-50/40">
        <div className="flex justify-between items-center">
          <p className="text-lg font-bold uppercase">Total Amount</p>
          <p className="text-4xl font-black font-heading">BND {finalTotal.toFixed(2)}</p>
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6 bba-card bba-card-accent border-orange-400 bg-orange-50/40">
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <p className="text-sm font-medium text-muted-foreground">Gross Amount</p>
          <p className="text-xl font-bold">BND {booking.gross_total.toFixed(2)}</p>
        </div>

        {hasDiscount && (
          <>
            <div className="flex justify-between items-center text-red-600">
              <div>
                <p className="text-sm font-medium">
                  Discount
                  {booking.discount_type && booking.discount_value && (
                    <span className="ml-1">
                      ({booking.discount_type === 'percentage'
                        ? `${booking.discount_value}%`
                        : `$${booking.discount_value}`})
                    </span>
                  )}
                </p>
                {booking.discount_reason && (
                  <p className="text-xs text-muted-foreground mt-0.5">
                    {booking.discount_reason}
                  </p>
                )}
              </div>
              <p className="text-xl font-bold">
                -${(booking.gross_total - booking.final_total).toFixed(2)}
              </p>
            </div>
            <div className="border-t pt-3" />
          </>
        )}

        <div className="flex justify-between items-center">
          <p className="text-lg font-bold uppercase">Net Amount</p>
          <p className="text-4xl font-black font-heading text-primary">
            BND {finalTotal.toFixed(2)}
          </p>
        </div>
      </div>
    </Card>
  );
}
